import { type Control, Controller, type FieldErrors, type UseFormRegister, type UseFormTrigger, type UseFormWatch } from 'react-hook-form'

import { PayDayInput } from './PayDayInput'
import { PayFrequencies, type PayFrequency, type PayScheduleFormInputs } from '../../types/payroll'
import { FormDateInputField } from '../reusable/form/FormFields'

interface PayDateFieldsProps {
  frequency: PayFrequency
  control: Control<any>
  register: UseFormRegister<any>
  errors: FieldErrors<PayScheduleFormInputs>
  watch: UseFormWatch<any>
  trigger: UseFormTrigger<any>
  getValues: () => any
}

const validateSecondDay = (value: number | undefined, firstDay: number | undefined) => {
  if (!firstDay || !value) return true
  return value > firstDay || 'First pay day must be before second pay day'
}

export function PayDateFields ({
  frequency,
  control,
  register,
  errors,
  watch,
  trigger,
  getValues,
}: PayDateFieldsProps) {
  return (
    <>
      {frequency === PayFrequencies.Monthly && (
        <div className='col-span-2'>
          <PayDayInput
            label='Monthly pay day'
            description="Enter a number between 1 and 31. For shorter months, we'll use the last day of the month."
            register={register}
            fieldName='firstDay'
            error={errors.firstDay}
          />
        </div>
      )}

      {frequency === PayFrequencies.SemiMonthly && (
        <div className='col-span-2grid grid-cols-2 gap-4 space-y-4'>
          <PayDayInput
            label='First pay day'
            register={register}
            fieldName='firstDay'
            onChange={() => trigger('secondDay')}
            error={errors.firstDay}
          />
          <PayDayInput
            label='Second pay day'
            register={register}
            fieldName='secondDay'
            error={errors.secondDay}
            validate={(value) => validateSecondDay(value, getValues()['firstDay'])}
            placeholder='ex. 15'
          />
        </div>
      )}

      {(frequency === PayFrequencies.BiWeekly || frequency === PayFrequencies.Weekly) && (
        <Controller
          name='examplePayDate'
          control={control}
          rules={{ required: true }}
          render={({ field: { onChange } }) => (
            <div className='space-y-2 col-span-2'>
              <label className='label-default font-medium text-ds-text-secondary block'>
                Example pay day
              </label>
              <span className='text-sm label-default text-ds-text-secondary block mb-2'>
                A previous or upcoming regular pay date not impacted by a holiday
              </span>
              <FormDateInputField
                fieldId='examplePayDate'
                fieldLabel=''
                watch={watch}
                onSelectDate={(date) => {
                  if (date) {
                    onChange(date.toISOString().split('T')[0])
                  } else {
                    onChange(undefined)
                  }
                }}
                serverError={errors.examplePayDate}
              />
              {errors.examplePayDate && <p className='text-red-500 text-xs'>This field is required</p>}
            </div>
          )}
        />
      )}
    </>
  )
}
